// Only carry selection intent. Prices, eligibility and stock are rechecked by the API.
export function rewardCartKey(items = [], countryId) {
    return JSON.stringify([String(countryId || ''), items.map(item =>
        [Number(item.product_id), Number(item.product_sku_id), Number(item.quantity)]
    ).sort((a, b) => a[1] - b[1])]);
}
